import alt from 'framework/alt';

class PreferenceActions {
  constructor() {
    this.generateActions(
      'updateSucceeded',
      'updateFailed',
      'updateStarted',
    );
  }
}

export default alt.createActions(PreferenceActions);
